/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { group_presence_AddGroupPresenceBody } from '../models/group_presence_AddGroupPresenceBody';
import type { group_presence_GroupPresenceSegmentResponse } from '../models/group_presence_GroupPresenceSegmentResponse';
import type { group_presence_OpenGroupPresenceResponse } from '../models/group_presence_OpenGroupPresenceResponse';
import type { group_presence_PresenceReportResponse } from '../models/group_presence_PresenceReportResponse';
import type { group_presence_UpdateGroupPresenceBody } from '../models/group_presence_UpdateGroupPresenceBody';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GroupPresenceService {
    /**
     * Add a group presence span for an employee (admin correction)
     * Group presence proof (#2114): adds a span with source admin. Refused with 422 when it overlaps another span of the employee (an open span counts as running), when it ends before it starts, crosses midnight or lies in the future. The proof marks it as corrected.
     * @param id Group ID
     * @param request The span
     * @returns group_presence_GroupPresenceSegmentResponse Created
     * @throws ApiError
     */
    public static postApiV1GroupsPresence(
        id: string,
        request: group_presence_AddGroupPresenceBody,
    ): CancelablePromise<group_presence_GroupPresenceSegmentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/groups/{id}/presence',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request format`,
                401: `Authentication required`,
                403: `Admin only`,
                409: `GROUP_PRESENCE_DISABLED`,
                422: `Validation error (overlap, window, group, employee)`,
                500: `Failed to correct group presence`,
            },
        });
    }
    /**
     * Get the group presence proof of one group (Praesenznachweis Personal)
     * Per day: every employee with a presence span or a planned shift in the group, their spans (corrected and late-added spans marked), the qualification held that day, the planned shifts, the children over the day, and at the children's peak the staff in the group beside the planned staff. Names employees, never a child. Admin: every group; a group lead: the groups they lead.
     * @param id Group ID
     * @param from First day YYYY-MM-DD
     * @param to Last day YYYY-MM-DD (at most 92 days including from)
     * @returns group_presence_PresenceReportResponse OK
     * @throws ApiError
     */
    public static getApiV1GroupsPresenceReport(
        id: string,
        from: string,
        to: string,
    ): CancelablePromise<group_presence_PresenceReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/groups/{id}/presence-report',
            path: {
                'id': id,
            },
            query: {
                'from': from,
                'to': to,
            },
            errors: {
                400: `Missing, unparseable, inverted or too long date range`,
                401: `Authentication required`,
                403: `shifts-absences module required, or a group the caller does not lead`,
                404: `Group not found`,
                500: `Failed to build the report`,
            },
        });
    }
    /**
     * Download the group presence proof as PDF
     * The Praesenznachweis Personal of one group for a date range, for the supervisory authority. German only. Same scope and validation as the JSON route; rate limited per organisation.
     * @param id Group ID
     * @param from First day YYYY-MM-DD
     * @param to Last day YYYY-MM-DD (at most 92 days including from)
     * @param lang Language
     * @returns binary PDF file
     * @throws ApiError
     */
    public static getApiV1GroupsPresenceReportPdf(
        id: string,
        from: string,
        to: string,
        lang: 'de' = 'de',
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/groups/{id}/presence-report/pdf',
            path: {
                'id': id,
            },
            query: {
                'from': from,
                'to': to,
                'lang': lang,
            },
            errors: {
                400: `Missing, unparseable, inverted or too long date range`,
                401: `Authentication required`,
                403: `shifts-absences module required, or a group the caller does not lead`,
                404: `Group not found`,
                429: `Rate limit exceeded`,
                500: `Failed to generate PDF`,
            },
        });
    }
    /**
     * Download the group presence proof as XLSX
     * The same report as the PDF as a workbook: sheet "Nachweis" (one row per employee and day, frozen header) and sheet "Tage" (the figures at the children's peak). German only. Same scope, validation and rate limit as the PDF.
     * @param id Group ID
     * @param from First day YYYY-MM-DD
     * @param to Last day YYYY-MM-DD (at most 92 days including from)
     * @param lang Language
     * @returns binary XLSX file
     * @throws ApiError
     */
    public static getApiV1GroupsPresenceReportXlsx(
        id: string,
        from: string,
        to: string,
        lang: 'de' = 'de',
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/groups/{id}/presence-report/xlsx',
            path: {
                'id': id,
            },
            query: {
                'from': from,
                'to': to,
                'lang': lang,
            },
            errors: {
                400: `Missing, unparseable, inverted or too long date range`,
                401: `Authentication required`,
                403: `shifts-absences module required, or a group the caller does not lead`,
                404: `Group not found`,
                429: `Rate limit exceeded`,
                500: `Failed to generate XLSX`,
            },
        });
    }
    /**
     * Remove a group presence span (admin, soft delete)
     * Group presence proof (#2114): soft-deletes the span; it stays in the audit trail with the admin as deleted_by.
     * @param id Span ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Presence(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/presence/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Authentication required`,
                403: `Admin only`,
                404: `Span not found`,
                409: `GROUP_PRESENCE_DISABLED`,
                500: `Failed to correct group presence`,
            },
        });
    }
    /**
     * Correct the window of a group presence span (admin)
     * Group presence proof (#2114): replaces the span with a corrected one (source admin) in one transaction; the original is soft-deleted and stays in the audit trail, so an employee's record is never rewritten. Ending an open span is an update with ended_at. Same validation as the add. Answers the new span.
     * @param id Span ID
     * @param request The new window
     * @returns group_presence_GroupPresenceSegmentResponse OK
     * @throws ApiError
     */
    public static patchApiV1Presence(
        id: string,
        request: group_presence_UpdateGroupPresenceBody,
    ): CancelablePromise<group_presence_GroupPresenceSegmentResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/presence/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request format`,
                401: `Authentication required`,
                403: `Admin only`,
                404: `Span not found`,
                409: `GROUP_PRESENCE_DISABLED`,
                422: `Validation error (overlap, window)`,
                500: `Failed to correct group presence`,
            },
        });
    }
    /**
     * List who is in which group right now
     * Group presence (#2114): every open span of the organisation, for the management app's "On shift now" row. A non-admin sees the groups they lead only. With the switch off group_presence_enabled is false and the list is empty.
     * @returns group_presence_OpenGroupPresenceResponse OK
     * @throws ApiError
     */
    public static getApiV1PresenceOpen(): CancelablePromise<group_presence_OpenGroupPresenceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/presence/open',
            errors: {
                401: `Authentication required`,
                403: `shifts-absences module required`,
                500: `Failed to load group presence`,
            },
        });
    }
}
